'use client';

import React from 'react';
import { Share2 } from 'lucide-react';

import { Button, type ButtonProps } from '@shaojiang/components/ui/button';
import { toaster } from '@shaojiang/lib/toaster';

interface ShareButtonProps extends Omit<ButtonProps, 'onClick'> {
  label: string;
  copiedLabel: string;
  title: string;
}

/** Opens the system share sheet, or copies the page link where there is none. */
export function ShareButton({ label, copiedLabel, title, ...props }: ShareButtonProps) {
  const share = async () => {
    const url = window.location.href;
    if (navigator.share) {
      await navigator.share({ title, url }).catch(() => undefined);
      return;
    }
    await navigator.clipboard.writeText(url);
    toaster.create({ type: 'success', title: copiedLabel });
  };

  return (
    <Button variant='outline' onClick={share} {...props}>
      <Share2 />
      {label}
    </Button>
  );
}
